import { Component, EventEmitter, Output, inject } from "@angular/core";
import { PropPropertyHeader } from "@app/integrations/urm/models/prop-property-header";
import { PropertyService } from "@app/integrations/urm/services/property.service";
import {
  ActionColumnConfig,
  ColumnConfig,
  DateColumnConfig,
  NumberColumnConfig,
  TemplateColumnConfig,
  WidgetColumnConfig
} from "@bryntum/grid-thin";
import { FormsModule } from "@angular/forms";
import {
  MatFormField,
  MatLabel,
  MatSuffix
} from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { GridComponent } from "../../../../view/shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";

@Component({
  selector: "urm-property-search",
  templateUrl: "./property-search.component.html",
  styleUrls: ["./property-search.component.css"],
  imports: [
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIconButton,
    MatSuffix,
    MatIcon,
    MatProgressSpinner,
    GridComponent,
    MatPaginator
  ]
})
export class PropertySearchComponent {
  private propertyService = inject(PropertyService);

  properties: PropPropertyHeader[] = [];
  isLoading = false;
  searchQuery = "";
  searchPerformed = false;

  // pagination state
  remoteTotal = 0;
  currentPage = 0;
  pageSize = 10;
  pageSizeOptions = [10];

  @Output() propertySelected = new EventEmitter<PropPropertyHeader>();

  columns: (
    | TemplateColumnConfig
    | ColumnConfig
    | DateColumnConfig
    | WidgetColumnConfig
    | NumberColumnConfig
    | ActionColumnConfig
  )[] = [
    {
      field: "Proh_PropertyName",
      text: "Property Name",
      flex: 1,
      editor: false
    },
    {
      field: "Proh_Address1",
      text: "Address 1",
      flex: 1,
      editor: false
    },
    {
      field: "Proh_Address2",
      text: "Address 2",
      flex: 1,
      editor: false
    },
    {
      field: "Proh_Address3",
      text: "Address 3",
      flex: 1,
      editor: false
    },
    {
      field: "Proh_Address4",
      text: "Address 4",
      flex: 1,
      editor: false
    },
    {
      field: "Proh_PostCode",
      text: "PostCode",
      flex: 1,
      editor: false
    },
    {
      type: "action",
      text: "Select",
      width: 80,
      actions: [
        {
          cls: "fa fa-check",
          tooltip: "Select Property",
          onClick: ({ record }) => {
            this.onSelect(record as unknown as PropPropertyHeader);
          }
        }
      ]
    }
  ];

  onSearch() {
    this.searchPerformed = true;
    this.isLoading = true;
    this.currentPage = 0; // reset to first page whenever a new search is performed
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.propertyService
      .loadPropertyByFilter(this.searchQuery, this.currentPage, this.pageSize)
      .then((result) => {
        this.properties = result.RootResults;
        this.remoteTotal = result.TotalCount; // assuming the result includes totalCount
        this.isLoading = false;
      })
      .catch((error) => {
        console.error("Search failed:", error);
        this.properties = [];
        this.remoteTotal = 0;
        this.isLoading = false;
      });
  }

  onSelect(property: PropPropertyHeader) {
    this.propertySelected.emit(property);
  }

  onPageEvent(event: { pageIndex: number; pageSize: number }) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadData();
  }
}
